// src/ImageGallery/UserCard.js
import React from 'react';

export default function UserCard({ user }) {
  if (!user) {
    return null; // Don't render if user data is missing
  }

  return (
    <div className="user-card" style={{ border: '1px solid #ccc', padding: '15px', margin: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <h3>{user.username}</h3>
      {user.email && <p>Email: {user.email}</p>}
      {/* You can add more user details here based on your UserSerializer, e.g.: */}
      {/* {user.city && <p>City: {user.city}</p>} */}
      {/* {user.phone_number && <p>Phone: {user.phone_number}</p>} */}
    </div>
  );
}